import React, { useEffect, useState } from "react";
import styles from "./RechargeProcessingContent.module.css";

interface RechargeProcessingContentProps {
  setOpenRechargeProcessing: (open: boolean) => void;
  setRechargeResult: (open: boolean) => void;
}

const RechargeProcessingContent: React.FC<RechargeProcessingContentProps> = ({ setOpenRechargeProcessing, setRechargeResult }) => {


  const closeHandler = () => {
    setOpenRechargeProcessing(false);
    document.body.classList.remove("no-overflow");
  };

  useEffect(() => {
    setTimeout(() => {
      setOpenRechargeProcessing(false);
      setRechargeResult(true)
    }, 5000)
  },[])

  return (
    <div className={styles.AtmbilpayContent}>
      <div className={styles.AtmbilpayImageBox}></div>
      <div className={styles.AtmbilpayTitle}>Recharge Processing</div>
      <div className={styles.AtmbilpayBillCard}>
        <div className={styles.StatusInfo}><span className={styles.Status}>Please Wait</span> while we verify your payment, <br/> Confirmation typically takes less than 60 seconds. If the transaction fails, any debited amount will be refunded</div>
        <div className={styles.Plan}>Plan</div>
        <div className={styles.PlanCardInfo}>
          <div className={styles.PlanCardInfoi}>
            <div className={styles.PlanCardLabel}>Price</div>
            <div className={styles.PlanCardData}><span className={styles.Rupees}>&#8377;</span> 420000</div>
          </div>
          <div className={styles.PlanCardInfoi}>
            <div className={styles.PlanCardLabel}>Validity</div>
            <div className={styles.PlanCardData}>365 Days</div>
          </div>
          <div className={styles.PlanCardInfoi}>
            <div className={styles.PlanCardLabel}>Balance</div>
            <div className={styles.PlanCardData}>50000 Credits</div>
          </div>
        </div>
      </div>
      <div className={styles.AtmbilpayActns}>
        <span className={`${styles.AtmbilpayCtaOutlined} CtaFilled`} onClick={closeHandler}>Close</span>
      </div>
    </div>
  );
};

export default RechargeProcessingContent;